export default __webpack_public_path__ + "static/media/aleth_blue.edec4865.svg";